<template>
    <div>
        <h5 class="header-text">Indication (複選)</h5>
        <v-checkbox v-for="item in items"
            :key="item.value"
            :label="item.text"
            :value="item.value"
            v-model="selected"
            hide-details
            @change="selectOne(item.value)"
        ></v-checkbox>
        <v-text-field
            v-if="showOthers"
            label="others"
            class="indication-others"
            :value="data.indicationOther"
            @change="selectOther($event)"
        ></v-text-field>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'IndicationInput',

    props: {
        data: {
            type: Object,
            required: true
        },
        hideDetails: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data () {
        return {
            selected: this.data.indicationIDs,
            shouldHideDetails: true,
            showOthers: false
        }
    },

    computed: {
        ...mapGetters('examinations', [
            'getInspectionInstrumentList'
        ]),
        items () {
            return this.$store.getters['examinations/getIndicationList']
        }
    },
    methods: {
        selectOne(value) {
            this.$emit('change', { field: 'indication', event: this.selected.join(",") })

            const othersValue = this.items[this.items.length -1].value
            if ( this.selected.indexOf(othersValue) >= 0) {
                this.showOthers = true
            } else {
                this.showOthers = false
                if (this.data.indicationOther == null || this.data.indicationOther.length > 0) {
                    this.selectOther('') 
                }
            }
        },
        selectOther(value) {
            this.$emit('change', { field: 'indicationOther', event: value })
        }
    },
    mounted() {
        const othersValue = this.items[this.items.length -1].value
        this.showOthers = this.selected.indexOf(othersValue) >= 0
    }
}
</script>